import { Controller } from "@hotwired/stimulus"
import { launchPageSignup, SignupCancelled } from "../../../frontend/src/shared/metaEmbeddedSignup"

// Connecting a Facebook Page to a brand: open Meta's dialog, hand the server
// the code it returns, and land the customer on the brand the page now feeds.
// The flow editor drives the same dialog through the same util, so Meta's
// protocol is described once.
export default class extends Controller {
  static targets = ["button", "error"]
  static values = {
    appId: String,
    configId: String,
    graphVersion: String,
    url: String,
    fallbackUrl: String,
    brandId: String,
  }

  async launch() {
    this.clearError()
    this.setBusy(true)

    try {
      const grant = await launchPageSignup({
        appId: this.appIdValue,
        configId: this.configIdValue,
        graphVersion: this.graphVersionValue,
      })

      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: JSON.stringify({ code: grant.code, brand_id: this.brandIdValue }),
      })

      const body = await response.json().catch(() => ({}))

      if (!response.ok) {
        this.showError(body.error || "That page could not be connected. Please try again.")
        return
      }

      window.location.assign(body.redirect_url || this.fallbackUrlValue)
    } catch (error) {
      // Backing out of Meta's dialog is a choice, not a failure.
      if (!(error instanceof SignupCancelled)) {
        this.showError(error.message)
      }
    } finally {
      this.setBusy(false)
    }
  }

  setBusy(busy) {
    this.buttonTargets.forEach((button) => {
      button.disabled = busy
    })
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.add("pu-alert", "pu-alert-danger")
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.errorTarget.classList.remove("pu-alert", "pu-alert-danger")
  }
}
